var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-3 col-lg-3 clor",on:{"click":function($event){return _vm.slotClick()}}},[_c('SideNav')],1),_c('div',{staticClass:"col-md-9 col-sm-9 col-lg-9"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }